import { render, staticRenderFns } from "./StaffAddEditModal.vue?vue&type=template&id=5949969a&"
import script from "./StaffAddEditModal.vue?vue&type=script&lang=js&"
export * from "./StaffAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports